import { useContext } from 'react'
import MollieContext, { MollieContextType } from '../context/MollieContext'

export function useMollie(): MollieContextType {
    return useContext(MollieContext)
}
